import React from "react";
import WidgetContainer from "@widgets/render-engine/widget-container";
import PickWidget from "@widgets/render-engine/pick-widget";

const CoreCompositeWidget = ({ data }) => {
    return (
        <>
            {data.items.map((item, index) => {
                return (
                    <WidgetContainer key={index} data={item.data}>
                        <PickWidget widget={item} />
                    </WidgetContainer>
                );
            })}
        </>
    );
};

const WidgetBox = ({ data }) => {
    const { boxType } = data;

    if (!boxType) return <CoreCompositeWidget data={data} />;

    if (boxType === "Card") {
        return (
            <div className="rounded-md p-4 shadow-md">
                <CoreCompositeWidget data={data} />
            </div>
        );
    }

    if (boxType === "CardNoShadow") {
        return (
            <div className="rounded-md border p-4 border-gray-200">
                <CoreCompositeWidget data={data} />
            </div>
        );
    }

    return <CoreCompositeWidget data={data} />;
};

export default WidgetBox;
